import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import apiService from '../services/apiService';
import bmailogo from '../assets/bmailogo.png';
const AdminLogin = () => {
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [isLogging, setIsLogging] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (field, value) => {
    setCredentials(prev => ({
      ...prev,
      [field]: value
    }));
    // Clear error when user starts typing
    if (error) {
      setError('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!credentials.username || !credentials.password) {
      setError('Please enter both username and password');
      return;
    }

    setIsLogging(true);

    try {
      const response = await apiService.adminLogin(credentials);
      
      if (response.access_token) {
        // Store tokens and expiration info in localStorage
        localStorage.setItem('admin_token', response.access_token);
        localStorage.setItem('admin_refresh_token', response.refresh_token);
        
        // Calculate and store expiration time
        const expiresAt = new Date(Date.now() + (response.expires_in * 1000));
        localStorage.setItem('admin_token_expires_at', expiresAt.toISOString());
        
        console.log('Login successful, tokens stored');
        
        // Redirect to admin dashboard
        navigate('/admin/dashboard');
      }
    } catch (error) {
      console.error('Login error:', error);
      setError(
        error.message || 
        'Login failed. Please check your credentials and try again.'
      );
    } finally {
      setIsLogging(false);
    }
  };

  return (
    <div className="container">
      <div className="header">
        <div style={{ marginBottom: '20px', textAlign: 'center' }}>
          <img 
            src={bmailogo} 
            alt="ByteMethod Logo" 
            style={{ maxWidth: '280px', height: 'auto' }}
          />
        </div>
        <h1 className="text-3xl md:text-4xl font-semibold mb-3 drop-shadow-lg">Opportunity Assessment Admin Login</h1>
        <p>Access the administration dashboard to manage and analyze survey responses</p>
      </div>

      <div className="card" style={{ maxWidth: '400px', margin: '0 auto' }}>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Username</label>
            <input
              type="text"
              className="form-control"
              value={credentials.username}
              onChange={(e) => handleInputChange('username', e.target.value)}
              placeholder="Enter admin username"
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="form-control"
              value={credentials.password}
              onChange={(e) => handleInputChange('password', e.target.value)}
              placeholder="Enter admin password"
              autoComplete="current-password"
            />
          </div>

          {error && (
            <div className="error-message" style={{ marginBottom: '15px' }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            className="btn btn-primary"
            style={{ width: '100%' }}
            disabled={isLogging}
          >
            {isLogging ? 'Logging in...' : 'Login'}
          </button>

          {isLogging && (
            <div className="loading" style={{ marginTop: '15px' }}>
              <div className="spinner"></div>
            </div>
          )}
        </form>

        <div style={{ marginTop: '20px', textAlign: 'center' }}>
          <a 
            href="/" 
            className="btn btn-primary"
            style={{ 
              width: '100%',
              textDecoration: 'none',
              display: 'inline-block',
              boxSizing: 'border-box'
            }}
          >
            ← Back to Survey
          </a>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;